import { ReactNode } from "react";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  title: string;
  subtitle?: ReactNode;
  icon?: IconDefinition;
  actions?: ReactNode;
};

export default function SectionHeader({ title, subtitle, icon, actions }: Props) {
  return (
    <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        {icon ? (
          <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-overlay-mid text-[14px] text-light-gray">
            <FontAwesomeIcon icon={icon} />
          </span>
        ) : null}
        <div className="min-w-0">
          <h2 className="font-[Gilroy-Bold] text-[18px] text-heading-color sm:text-[20px]">
            {title}
          </h2>
          {subtitle ? (
            <p className="mt-0.5 font-[Gilroy-Medium] text-[13px] text-light-gray sm:text-[14px]">
              {subtitle}
            </p>
          ) : null}
        </div>
      </div>
      {actions ? (
        <div className="flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:flex-wrap lg:w-auto lg:justify-end">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
